declare namespace $ {

	export class $shm_agent_media extends $shm_media {
	}
	
}

//# sourceMappingURL=media.view.tree.d.ts.map